import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { discordCdn, getApplys } from "../utils/api";
import Modal from "../components/apply/Modal";

export default function Applys() {
  const { id } = useParams<{ id: string }>();
  const [applys, setApplys] = useState<any[]>([]);
  const [user, setUser] = useState<{ id: string }>({ id: "" });
  const [q, setQ] = useState<{}>({});
  const [notApplys, setNotApplys] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [AlertS, setAlertS] = useState(false);
  const [AlertM, setAlertM] = useState("");

  useEffect(() => {
    getApplys(id as string)
      .then((response) => {
        console.log(response.data);
        if (response.status === 201) setApplys(response.data);
        else if (response.status === 350 || response.data <= 1) setNotApplys(true);
        else window.location.href = "/";
      })
      .catch((error) => {
        if (error.response?.status !== 350) window.location.href = "/";
        else setNotApplys(true);
      });
  }, [id]);

  if (notApplys) {
    return <p>No users have applied to the server: {id}</p>;
  } else {
    return (
      <>
        <Modal
          seS={setAlertS}
          seM={setAlertM}
          eM={AlertM}
          eS={AlertS}
          server={id as string}
          S={showModal}
          qs={q as any}
          id={user?.id as string}
          HH={() => setShowModal(false)}
        />
        <div className="container mt-4">
          <div className="row">
            {applys.map((a: any) => (
              <div className="col-md-6 mb-4" key={a?._id}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="mt-3">Username: {a?.user?.username}</h5>
                    <p className="mb-0">User ID: {a?.user?.id}</p>
                    <img
                      src={
                        discordCdn +
                        "avatars/" +
                        a.user.id +
                        "/" +
                        a?.user.avatar
                      }
                      alt={a?.user.username}
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                      className="img-thumbnail"
                    />
                    <p className="mt-2">CreatedAt: {a?.createAt}</p>
                    <button
                      onClick={() => {
                        setUser(a.user);
                        setQ(a.reply);
                        setShowModal(true);
                      }}
                      className="btn btn-primary"
                    >
                      Open Modal for {a?.user.username}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}
